<template>
  <div class="report-section report-section-cover">
    <div class="cover-content">
      <!-- <div v-if="reportData.options?.name || reportData.name" class="cover-title">{{ reportData.options?.name || reportData.name }}</div> -->
      <div v-if="reportData.options?.report_title || reportData.report_title" class="cover-title">{{ reportData.options?.report_title || reportData.report_title }}</div>
      <div v-if="reportData.options?.description || reportData.description" class="cover-description">{{ reportData.options?.description || reportData.description }}</div>
      <div class="cover-divider" :style="dividerStyle" />
      <div v-if="showCreateTime" class="cover-info">{{ currentDate }}</div>
    </div>
    <div v-if="showCompanyInfo" class="cover-company-info">
      <img v-if="companyLogoUrl" :src="companyLogoUrl" alt="logo" class="cover-logo" />
      <div v-if="companyName" class="cover-company">{{ companyName }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportCover',
  props: {
    reportData: {
      type: Object,
      default: () => ({}),
    },
    scopeParams: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    showCreateTime () {
      return this.reportData.options?.create_time === true || this.reportData.create_time === true
    },
    currentDate () {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    companyLogoUrl () {
      const logo = this.reportData.options?.company_logo || this.reportData.company_logo
      const format = this.reportData.options?.company_logo_format || this.reportData.company_logo_format || 'image/png'
      if (logo) {
        return `data:${format};base64,${logo}`
      }
      return null
    },
    companyName () {
      return this.reportData.options?.company || this.reportData.company || ''
    },
    showCompanyInfo () {
      return !!(this.companyLogoUrl || this.companyName)
    },
    themeColor () {
      return this.$store.getters.themeColor || '#1890FF'
    },
    dividerStyle () {
      const color = this.themeColor
      return {
        background: `linear-gradient(to right, transparent, ${color} 50%, transparent)`,
      }
    },
  },
  methods: {
    getTemplateParams () {
      return {}
    },
  },
}
</script>

<style lang="less" scoped>
.report-section-cover {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(1123px - 100px); /* A4 页面高度减去页眉页脚 */
  padding: 40px;
  position: relative;
  .cover-content {
    text-align: center;
    max-width: 600px;
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .cover-title {
      color: #000;
      font-size: 36px;
      font-weight: bold;
      margin-bottom: 20px;
      line-height: 1.4;
      transform: translateY(-150px);
    }
    .cover-description {
      color: #666;
      font-size: 26px;
      margin-bottom: 30px;
      line-height: 1.6;
      transform: translateY(-150px);
    }
    .cover-divider {
      width: 100%;
      height: 4px;
      margin: 10px 0;
      transform: translateY(-150px);
    }
    .cover-info {
      position: absolute;
      bottom: 100px;
      left: 50%;
      transform: translateX(-50%);
      color: #666;
      font-size: 18px;
      line-height: 1.6;
    }
  }
  .cover-company-info {
    position: absolute;
    top: 40px;
    left: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;
    padding: 20px 0;
    .cover-logo {
      max-width: 20px;
      max-height: 20px;
      width: 20px;
      height: 20px;
      object-fit: contain;
    }
    .cover-company {
      color: #999;
      font-size: 16px;
      line-height: 1.6;
    }
  }
}
</style>
